<div class="box">
  <div class="box-row header">
    <app-header-bar [title]="'workflow-email.title'"></app-header-bar>
  </div>
  <div class="content mt-2 mb-3">
    <div class="row">
      <app-datatable [dataSource]="source" [columns]="columns" [identifier]="'workflows-emails'" [iconActions]="iconActions"
        (showEvent)="show($event.valueOf())" (newEvent)="new()">
        <app-empty-table [icon]="'rebase'" [emptyText]="'workflow-email.empty_text' | translate"
          [buttonText]="'createNew' | translate" (btnClick)="new()">
        </app-empty-table>
      </app-datatable>

      <app-error [error]="error"></app-error>

      <app-model-modal #EditModal (saveEvent)="onSave()" (secondaryAction)="onTest()"
        [secondaryActionText]="'workflow-email.test-email'" [secondaryActionEnabled]="testEmailButtonEnabled">
        <app-email-form #form (closeEvent)="onModalClose()"
          (loadingEvent)="onLoading($event.valueOf())"></app-email-form>
      </app-model-modal>
    </div>
  </div>
</div>
